import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../core/services/authentication.service";
import {
  ONBOARDING_STORAGE_KEY,
  OnboardingWizardComponent,
} from "../routes/onboarding/onboarding-wizard.component";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
})
export class LayoutComponent implements OnInit {
  constructor(
    private authenticationService: AuthenticationService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    const user = this.authenticationService.currentUser();
    const hasCompletedOnboarding =
      localStorage.getItem(ONBOARDING_STORAGE_KEY) === "true";

    if (user && !hasCompletedOnboarding) {
      this.modalService.open(OnboardingWizardComponent, {
        size: "lg",
        backdrop: "static",
        centered: true,
      });
    }
  }
}
